<template>
  <c-modal title='Patch Data' v-model="open" size="lg">
      <c-scroll-view style="height:600px">
        <span v-for="r in p" v-bind:key="r.id">
            <c-row>
                <c-col>
                    <span class="u-color-success u-font-bold">{{r.display}}</span>
                    <span class="u-fr">
                        <a @click="onSavePatch(r, r.id)" href="#"><i class="icon-floppy-disk u-color-success"></i><span class="u-color-success u-ml-5">SAVE CHANGES</span></a>
                        <a @click="onRevertPatch(r, r.id)"  href="#" class="u-ml-10"><i class="icon-undo u-color-success"></i><span class="u-color-success u-ml-5">REVERT PATCH</span></a>
                    </span>
                </c-col>
            </c-row>
            <c-row>
                <c-col>&nbsp;</c-col>
                <c-col>Original value</c-col>
                <c-col>Patch</c-col>
            </c-row>
            <c-row v-for="f in r.data" v-bind:key="f.field">
                <c-col>{{f.display}}:</c-col>
                <c-col>
                    <c-form-input readonly v-model="f.original"/>
                </c-col>
                <c-col>
                    <c-form-input v-model="f.patch"/>
                </c-col>
            </c-row>
            <c-row>
                <c-col>&nbsp;</c-col>
            </c-row>
        </span>
      </c-scroll-view>
  </c-modal>
</template>
<script>
import { mapState } from 'vuex'
import axios from 'axios'
import { EventBus } from '../event-bus.js'

export default {
  name: 'PatchData',

  props: ['patches'],

  data () {
    return {
      open: false,
      p: this.patches
    }
  },
  computed: {
    ...mapState('auth', ['clientCode']),
    ...mapState('client', ['requestProperties'])
  },
  methods: {
    show (data, requestId, artefactId) {
      // this.client = window.sessionStorage.getItem('client')
      this.p = []
      this.p = data
      this.open = true
      this.request_id = requestId
      this.artefact_id = artefactId
    },

    validateBeforeSubmit () {
      this.$validator.validateAll().then(result => {
        if (result) {
          // eslint-disable-next-line
          // do something if data is validated
        }
      })
    },

    onSavePatch (patchData, id) {
      console.log('Save patch ' + id)
      let url = process.env.API + this.clientCode + '/' + this.request_id + '/' + this.artefact_id + '/patches'
      let dt = new Date()
      EventBus.$emit('show-loading')
      axios.post(url,
        patchData,
        {
          headers: {
            Authorization: window.sessionStorage.getItem('token')
          }
        })
        .then(response => {
          EventBus.$emit('hide-loading')
          this.$snotify.success(
            'Patch saved successfully',
            null,
            {
              position: 'centerTop',
              timeout: 3000,
              showProgressBar: false
            }
          )
        })
        .catch(reason => {
          console.error('Could not save patch')
          console.error(reason)
          EventBus.$emit('hide-loading')
          this.$alert({
            type: 'error',
            title: 'Could not save artefact patch',
            showCancel: false,
            confirmText: 'Close'
          })
        })
    },

    onRevertPatch (patchData, id) {
      console.log('Revert patch ' + id)
      for (var i = 0; i < patchData.data.length; i++) {
        patchData.data[i].patch = patchData.data[i].original
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PatchData.vue